/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class CandidateReputationClarificationEntity extends Entity {
  candidateId: string = '';
  createdAt: string | null = null;
  id: string = '';
  opportunityId: string = '';
  submissionComments: string | null = null;
  submissionCommentsUpdatedAt: string | null = null;
  submissionCommentsUpdatedBy: string | null = null;
  updatedAt: string | null = null;
  static override key = 'CandidateReputationClarification';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateReputationClarification' in input
    ) {
      const { CandidateReputationClarification: wrapped, ...rest } = input as {
        CandidateReputationClarification: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}